// Animated headline: each word rises in (CSS-only so it never delays LCP).
export default function AnimatedTitle({ text, accent = "", className = "", as = "h1", testid, baseDelay = 0, underline = true }) {
  const H = as;
  const words = text.split(" ").filter(Boolean);
  const accentWords = accent.split(" ").filter(Boolean);
  let i = 0;
  const word = (w, isAccent) => {
    const d = baseDelay + i++ * 70;
    return [
      <span key={`${w}-${i}`} className="inline-block">
        <span className={`word-rise ${isAccent ? "accent-italic" : ""}`} style={{ animationDelay: `${d}ms` }}>
          {w}
        </span>
      </span>,
      " ",
    ];
  };
  return (
    <H className={className} data-testid={testid}>
      <span>
        {words.map((w) => word(w, false))}
        {accentWords.length > 0 && (
          <span className={underline ? "relative inline-block whitespace-nowrap" : "inline"}>
            {accentWords.map((w) => word(w, true))}
            {underline && <svg
              aria-hidden="true"
              className="pointer-events-none absolute left-0 -bottom-[0.34em] h-[0.26em] w-[calc(100%-0.25em)] text-[#5D6F59] opacity-50"
              viewBox="0 0 300 20"
              preserveAspectRatio="none"
            >
              <path
                d="M2 14 C 60 4, 120 4, 170 11 S 260 18, 298 6"
                fill="none"
                stroke="currentColor"
                strokeWidth="5"
                strokeLinecap="round"
                pathLength="1"
                className="draw-path"
                style={{ animationDelay: `${baseDelay + (words.length + accentWords.length) * 70 + 200}ms` }}
              />
            </svg>}
          </span>
        )}
      </span>
    </H>
  );
}
